import { useNavigate } from 'react-router-dom';
import { useLayoutEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../shared/libs/redux';
import {
	setActiveWorkshopTemplate,
	setWorkshopDuplicateModalActive,
	workshopTemplateSlice,
} from '../../../../entities/template/workshop/template/model/slice';
import { workshopTemplateAPI } from '../../../../entities/template/workshop/template/api/api';
import { WorkshopTemplateInfoModal } from '../template-info-modal';
import { useUnbindCategoryToWorkshopTemplate } from '../unbind-tag/api/useUnbindCategoryToWorkshopTemplate';
import { personalAccountSlice } from '../../../../entities/user/account/personalAccountReducer';
import { useEditWorkshopTemplateName } from '../../../template/edit-name';

export const WorkshopTemplateInfoModalWrapper = () => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	const isBasicTariff = useAppSelector(personalAccountSlice.selectors.isBasicTariff);

	const id = useAppSelector(state => state.workshopTemplate.selectedTemplateId);
	const { data, error } = workshopTemplateAPI.useGetQuery({ id: id || '' }, { skip: !id });
	const { template } = data || {};

	const { onUnbindCategory } = useUnbindCategoryToWorkshopTemplate(template?.id || '');
	const { editName } = useEditWorkshopTemplateName(template?.id || '');

	const isActive = useAppSelector(workshopTemplateSlice.selectors.getIsTemplateInfoModalActive);

	const setModalVisibility = (value: boolean) => {
		dispatch(workshopTemplateSlice.actions.setIsTemplateInfoModalActive(value));
	};

	const onClose = () => {
		setModalVisibility(false);
		dispatch(workshopTemplateSlice.actions.setSelectedTemplateId(null));
	};

	const onDuplicate = () => {
		dispatch(setActiveWorkshopTemplate(id));
		dispatch(setWorkshopDuplicateModalActive(true));
	};

	useLayoutEffect(() => {
		if (error && 'originalStatus' in error && error.originalStatus === 403) {
			navigate('/collection/forbidden');
		}
	}, [error, navigate]);

	if (!data) return null;

	return (
		<WorkshopTemplateInfoModal
			isActive={isActive}
			onClose={onClose}
			editName={editName}
			unbindCategory={onUnbindCategory}
			data={data}
			onDuplicate={onDuplicate}
			isPDFAvailable={isBasicTariff}
		/>
	);
};
